const cashierBonusTypes = {
    GET_CASHIER_BONUS_ANALYTICS_PENDING: "GET_CASHIER_BONUS_ANALYTICS_PENDING",
    GET_CASHIER_BONUS_ANALYTICS_SUCCESS: "GET_CASHIER_BONUS_ANALYTICS_SUCCESS",
    GET_CASHIER_BONUS_ANALYTICS_ERROR: "GET_CASHIER_BONUS_ANALYTICS_ERROR",
    GET_CASHIER_TRANSACTIONS_PENDING: "GET_CASHIER_TRANSACTIONS_PENDING",
    GET_CASHIER_TRANSACTIONS_SUCCESS: "GET_CASHIER_TRANSACTIONS_SUCCESS",
    GET_CASHIER_TRANSACTIONS_ERROR: "GET_CASHIER_TRANSACTIONS_ERROR",
}

export default cashierBonusTypes;
